var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCouponIconinline = function SvgCouponIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.588 8.64a.804.804 0 0 0-1.609 0v2.573a.804.804 0 0 0 1.609 0V8.64Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.768 8.409a.81.81 0 0 0 .399-.695V4.781a1.45 1.45 0 0 0-1.448-1.448H2.281A1.45 1.45 0 0 0 .833 4.781v2.927a.81.81 0 0 0 .4.694c.553.322.887.895.887 1.518 0 .624-.334 1.197-.888 1.519a.81.81 0 0 0-.399.694v2.927c0 .798.65 1.448 1.448 1.448h15.438a1.45 1.45 0 0 0 1.448-1.448v-2.927a.81.81 0 0 0-.399-.694 1.754 1.754 0 0 1-.888-1.519c0-.623.335-1.196.888-1.518v.007ZM6.784 12.982a.804.804 0 0 0-.804.805v1.125H2.442v-2.348a3.395 3.395 0 0 0 1.286-2.637c0-1.016-.482-2-1.286-2.638V4.942H5.98v1.125a.804.804 0 0 0 1.608 0V4.942h9.97v2.347a3.395 3.395 0 0 0-1.286 2.638c0 1.016.483 2 1.287 2.637v2.348H7.588v-1.125a.804.804 0 0 0-.804-.805Z",
    fill: "#252525"
  })));
};
export default SvgCouponIconinline;